import React from 'react';

const SpotifyEmbed = ({ type, assetPath, title }) => (
  <div className="post-aside">
    <iframe
      src={`https://open.spotify.com/embed/${type}/${assetPath}`}
      width="100%"
      height="152"
      frameBorder="0"
      allow="encrypted-media"
      loading="lazy"
      title={`Spotify ${type}: ${title}`}
    />
  </div>
);

export default SpotifyEmbed;
